import cookie from 'vue-cookies'
import { captureApiError } from '@/shared/lib/captureApiError'

const WALLET_HIDE_COOKIE = 'isWalletHidden'

function initState() {
  return {
    isBalanceHidden: !!cookie.get(WALLET_HIDE_COOKIE),
  }
}

const state = initState()

const mutations = {
  SET_BALANCE_HIDDEN(state, value) {
    state.isBalanceHidden = value
  },
}

const actions = {
  ON_HIDE_TOGGLE({ state, commit }) {
    const newValue = !state.isBalanceHidden
    commit('SET_BALANCE_HIDDEN', newValue)
    if (newValue) {
      cookie.set(WALLET_HIDE_COOKIE, true)
    } else {
      cookie.remove(WALLET_HIDE_COOKIE)
    }
  },

  // Check that user has status No Pay - return true or false. Return false by default
  async GET_NO_PAY() {
    try {
      const data = await this.$apiService().emcdApi.get('v1/settings/nopay')
      return data.no_pay
    } catch (error) {
      console.error('GET_NO_PAY', error)
      captureApiError('GET_NO_PAY', 'v1/settings/nopay', error)
      return false
    }
  },

  // Check that user have passed KYC - return true or false. Return false by default
  async GET_KYC_STATUS() {
    try {
      const data = await this.$apiService().get('kyc/status')
      return data.kyc_status === 2
    } catch (error) {
      console.error('GET_KYC_STATUS', error)
      captureApiError('GET_KYC_STATUS', 'kyc/status', error)
      return false
    }
  },

  // Check that user enables 2FA - return true or false. Return true by default
  async GET_2FA() {
    try {
      const data = await this.$apiService().get('profile/2fa_setup')
      return data.is_2fa_google_enabled || data.is_2fa_mobile_enabled
    } catch (error) {
      console.error('GET_2FA', error)
      captureApiError('GET_2FA', 'profile/2fa_setup', error)
      return true
    }
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
